import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListModuleProfileResponse } from '../../responses/admin-user/list-module-profile.response';

@Injectable({
  providedIn: 'root'
})
export class ModuleProfileService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listModule(): Observable<ListModuleProfileResponse> {
    
    let uri = 'ModuleProfile' 
    
    return this.httpClient.get<ListModuleProfileResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
